import React from 'react';
import ConversationItem from './ConversationItem';
import { PENDING } from '../../../../store/globalStatuses/globalStatuses';
import styles from '../../WabaChats.module.scss';

export default function ConversationList({ conversations, activeConversationId, status, onSelect }) {
    if (status === PENDING && conversations.length === 0) {
        return <div className={styles.loading}>Loading...</div>;
    }
    if (conversations.length === 0) {
        return <div className={styles.emptyList}>No conversations yet</div>;
    }
    return (
        <div className={styles.conversationList}>
            {conversations.map(conv => (
                <ConversationItem key={conv.id} conversation={conv} isActive={conv.id === activeConversationId} onClick={() => onSelect(conv.id)} />
            ))}
        </div>
    );
}
